import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/notification-badge/notification-badge.component.js'

const tagName = 'dap-ds-notification-badge'

/**
 * `dap-ds-notification-badge`
 * @summary A notification badge component is a user interface element that visually indicates the presence of new information or updates, often displaying a numeric count of unread notifications, messages, or items requiring attention.
 * @element dap-ds-notification-badge
 * @title - Notification badge
 *
 * @slot - The content of the notification badge.
 *
 * @csspart base - The main container of the notification badge.
 * @csspart noty - The notification badge container.
 *
 * @cssproperty --dds-notification-badge-size - Controls the overall size of the notification badge
 * @cssproperty --dds-notification-badge-min-width - Minimum width of the notification badge
 * @cssproperty --dds-notification-badge-height - Height of the notification badge
 * @cssproperty --dds-notification-badge-padding - Padding inside the notification badge
 * @cssproperty --dds-notification-badge-border-radius - Border radius of the notification badge
 * @cssproperty --dds-notification-badge-font-size - Font size of the notification badge text
 * @cssproperty --dds-notification-badge-dot-size - Size of the dot variant
 * @cssproperty --dds-notification-badge-color - Text color of the notification badge
 * @cssproperty --dds-notification-badge-neutral-bg - Background color for neutral type
 * @cssproperty --dds-notification-badge-brand-bg - Background color for brand type
 * @cssproperty --dds-notification-badge-info-bg - Background color for info type
 * @cssproperty --dds-notification-badge-positive-bg - Background color for positive type
 * @cssproperty --dds-notification-badge-warning-bg - Background color for warning type
 * @cssproperty --dds-notification-badge-negative-bg - Background color for negative type
 * @cssproperty --dds-notification-badge-circular-offset-x - Horizontal offset for circular positioning
 * @cssproperty --dds-notification-badge-circular-offset-y - Vertical offset for circular positioning
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DapDSNotificationBadge',
})

export default reactWrapper
